import { FormattedMessage, injectIntl } from "react-intl";
import { Formik } from "formik";
import { NotFoundError } from "../../api";
import { SubmitButton, ObjectsTypeahead } from "../Form";
import { ObjectsType } from "../../constants";
import { accessRightsShape, assetShape, intlShape } from "../../shapes";
import { withApi, apiShape, withNotifier, notifierShape } from "../../context";
import List from "../List/List";
import AssetItem from "../Assets/AssetItem";
import Hint from "../Hint";

export type AssetAssignObject = {
  id: number;
  itemType: "node" | "instrumentation";
};

type Props = {
  intl: intlShape;
  notifier: notifierShape;
  api: apiShape;
  object?: AssetAssignObject;
  accessRights?: accessRightsShape;
  assets?: assetShape[];
  onAssignedAssetsChanged: () => Promise<void>;
};

export function AssetsAssignList(props: Props) {
  const {
    intl,
    api,
    notifier,
    accessRights,
    object,
    assets = [],
    onAssignedAssetsChanged,
  } = props;

  const objectId = object?.id;

  const parentInstrumentation =
    object?.itemType === "instrumentation" ? { id: objectId } : null;
  const parentNode = object?.itemType === "node" ? { id: objectId } : null;

  const handleOnAssetRemoved = async () => {
    await onAssignedAssetsChanged();
  };

  const assignAsset = async (values: $TSFixMe, { resetForm }: $TSFixMe) => {
    const payload = { assets: [{ id: values.asset.id }] };
    try {
      await api.post(`/${object?.itemType}s/${objectId}/assets`, payload);
      await onAssignedAssetsChanged();
      notifier.showSuccess(
        intl.formatMessage({ id: "asset.actions.assign.notification" }),
      );
    } catch (error) {
      if (!(error instanceof NotFoundError)) {
        notifier.showError(api.translateError(error));
      }
    }
    resetForm({ values: {} });
  };

  const renderAssetAssignForm = (formProps: $TSFixMe) => {
    const { handleSubmit, isSubmitting, values } = formProps;
    return (
      <form onSubmit={handleSubmit} noValidate>
        <ObjectsTypeahead
          {...formProps}
          id="asset-typeahead"
          name="asset"
          label={intl.formatMessage({ id: "asset.actions.assign" })}
          placeholder={intl.formatMessage({ id: "label.serial_number" })}
          objectsToIgnore={assets}
          objectsType={ObjectsType.Assets}
        />
        <div className="btn-group">
          <SubmitButton
            id="assign-asset-button"
            disabled={!values.asset}
            fetching={isSubmitting}
            text={intl.formatMessage({ id: "button.assign" })}
          />
        </div>
      </form>
    );
  };

  return objectId && assets ? (
    <div id="asset-list">
      <h2>
        <FormattedMessage id="assets_list.header" />
      </h2>
      {accessRights?.canPermit ? (
        <Formik
          id="assign-asset-formik"
          onSubmit={assignAsset}
          initialValues={{}}
        >
          {renderAssetAssignForm}
        </Formik>
      ) : null}
      {(assets as $TSFixMe).length > 0 ? (
        <List id="assets_assign_list">
          {(assets as $TSFixMe).map((asset: $TSFixMe) => (
            <AssetItem
              key={asset.id}
              // @ts-expect-error TS(2322) FIXME: Type '{ key: any; asset: any; parentNode: { id: nu... Remove this comment to see the full error message
              asset={asset}
              parentNode={parentNode}
              parentInstrumentation={parentInstrumentation}
              onAssetRemoved={handleOnAssetRemoved}
              showItemMenu
              parentAccessRights={accessRights}
            />
          ))}
        </List>
      ) : (
        <Hint
          id="hint-no-assets-assigned"
          details={intl.formatMessage({ id: "asset_list.no_assets_assign" })}
        />
      )}
    </div>
  ) : null;
}

export default injectIntl(withNotifier(withApi(AssetsAssignList)));
